import { useFormaliteService } from '@europrocurement/l2d-domain';
import {
    DossierOpenSearchApiApiOpensearchValideursStatusGetCollectionRequest,
    DossierOpenSearchJsonldOpensearchDossierValideursStatusRead,
} from '@europrocurement/l2d-domain/openApi/ApiFormalite';

export type DossierValideursStatus = DossierOpenSearchJsonldOpensearchDossierValideursStatusRead &
    Record<string, unknown>;

const useDossierValideurs = () => {
    const { dossierOpenSearchApi } = useFormaliteService();
    let searchValideurTimeout: number | undefined;

    const searchDossierValideursStatus = (term: string): Promise<Array<DossierValideursStatus>> =>
        new Promise((resolve, reject) => {
            clearTimeout(searchValideurTimeout);
            const requestParameters: DossierOpenSearchApiApiOpensearchValideursStatusGetCollectionRequest =
                { q: term };

            searchValideurTimeout = setTimeout(() => {
                dossierOpenSearchApi
                    .apiOpensearchValideursStatusGetCollection(requestParameters)
                    .then((res) =>
                        resolve(res.data['hydra:member'] as Array<DossierValideursStatus>),
                    )
                    .catch(() => reject());
            }, 300);
        });

    return { searchDossierValideursStatus };
};

export default useDossierValideurs;
